export const exportContactCopy = {
  header: '',
  confirmBtnText: '',
  successToast: '',
};
